module.exports = __webpack_public_path__ + "img/Cara_Amarilla.8496b752.svg";